
import React from 'react';
import { motion } from 'framer-motion';
import { Bike, ArrowLeft, Zap, ChevronRight } from 'lucide-react';
import { Driver } from '../../types';

interface LoginProps {
  drivers: Driver[];
  onLogin: (driverId: string) => void;
  onBackToDispatcher: () => void;
}

export const DriverLogin: React.FC<LoginProps> = ({ drivers, onLogin, onBackToDispatcher }) => {
  return (
    <div className="min-h-screen bg-app-bg text-text-primary flex flex-col items-center justify-center p-6 relative overflow-hidden">
      <div className="absolute top-0 left-0 w-64 h-64 bg-sal-cyber-teal/5 rounded-full blur-3xl -translate-x-1/2 -translate-y-1/2 pointer-events-none"></div>
      <div className="absolute bottom-0 right-0 w-64 h-64 bg-sal-solid-indigo/5 rounded-full blur-3xl translate-x-1/2 translate-y-1/2 pointer-events-none"></div>
      
      <div className="relative z-10 w-full max-sm">
        <div className="text-center mb-12">
            <div className="w-20 h-20 bg-card-bg border-2 border-sal-cyber-teal rounded-3xl mx-auto flex items-center justify-center shadow-[0_0_40px_rgba(6,182,212,0.2)] mb-6 rotate-3">
                <Bike className="w-10 h-10 text-sal-cyber-teal" />
            </div>
            <h1 className="text-3xl font-black text-text-primary tracking-tighter uppercase mb-1">Central do Piloto</h1>
            <p className="text-text-muted text-sm font-bold uppercase tracking-[0.2em]">S.A.L. Mobile Interface</p>
        </div>

        <div className="grid grid-cols-1 gap-3">
            {drivers.filter(d => d.status !== 'offline').map(driver => (
                <motion.button
                    type="button"
                    key={driver.id}
                    whileHover={{ scale: 1.02 }}
                    whileTap={{ scale: 0.98 }}
                    onClick={() => onLogin(driver.id)}
                    className="bg-card-bg/90 backdrop-blur-xl border border-border-dim p-4 rounded-2xl flex items-center gap-4 hover:bg-app-bg hover:border-sal-cyber-teal/30 transition-all shadow-xl group"
                >
                    <div className="w-14 h-14 bg-card-bg border-2 border-sal-cyber-teal/20 rounded-2xl flex items-center justify-center text-2xl font-black text-sal-cyber-teal shadow-inner group-hover:border-sal-cyber-teal transition-colors">
                        {driver.name.charAt(0)}
                    </div>
                    <div className="flex-1 text-left">
                        <span className="block text-text-primary font-black text-xl leading-none mb-1">{driver.name}</span>
                        <span className="text-xs text-text-muted font-black uppercase tracking-widest flex items-center gap-1">
                            <Zap className="w-3 h-3 text-sal-gold fill-current" /> Pronto para Missão
                        </span>
                    </div>
                    <ChevronRight className="w-5 h-5 text-icon-muted group-hover:text-sal-cyber-teal transition-colors" />
                </motion.button>
            ))}
            
            {drivers.filter(d => d.status !== 'offline').length === 0 && (
                <div className="text-center py-10 bg-card-bg rounded-2xl border border-dashed border-border-dim">
                    <p className="text-text-muted text-sm font-bold uppercase">Nenhum piloto ativo na base.</p>
                </div>
            )}
        </div>

        <button type="button" onClick={onBackToDispatcher} className="w-full mt-10 text-text-muted text-xs font-black uppercase tracking-[0.3em] hover:text-text-primary transition-colors flex items-center justify-center gap-2 py-4 rounded-xl border border-transparent hover:border-border-dim">
            <ArrowLeft className="w-4 h-4" /> Retornar à Base
        </button>
      </div>
    </div>
  );
};
